import { Product } from '../../product';

export interface AssetEssentials<T = Date> {
  product: Product<T>;
  contractId: string;
  quantity: number;
  apiKeys: string[];
  portalAccess: boolean;
  groupName: string | null;
}
